import { createPortal } from "react-dom";
import { DragOverlay } from "@dnd-kit/core";
import styled from "styled-components";

import { ValueCell } from "../SimpleComponentVisualization";
import {
  ItemContent,
  ItemMomentCell,
  ItemSourceCell,
  ItemView,
} from "./LimitedListCells";
import { ListItem } from "./limitedListItems";
import { DragHandle, DragHandleCell } from "./SortableItemRow";

// The floating copy of the row being dragged. It rides in a body-level
// portal, so it needs its own table wrapper and a solid background.
const OverlayTable = styled.table`
  background: var(--bs-body-bg);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  margin-bottom: 0;
`;

// The dragged row's floating copy. It lives in a body-level portal, outside
// the scrolling area, so dragging never grows the table's scroll extents;
// with an overlay present, dnd-kit leaves the source row in place.
const LimitedListDragOverlay = ({
  item,
  view,
}: {
  item: ListItem | null;
  view: ItemView;
}) =>
  createPortal(
    <DragOverlay dropAnimation={null}>
      {item ? (
        <OverlayTable
          className="table font-monospace"
          data-testid="limited-list-drag-overlay"
        >
          <tbody>
            <tr>
              <DragHandleCell>
                {/* The floating copy rides under the pointer for the whole
                    drag, so its handle always shows the grabbing cursor. */}
                <DragHandle
                  type="button"
                  className="bi-grip-vertical"
                  style={{ cursor: "grabbing" }}
                />
              </DragHandleCell>
              <ItemSourceCell item={item} />
              <ValueCell $compactView={view.compact}>
                <ItemContent item={item} view={view} />
              </ValueCell>
              <ItemMomentCell item={item} view={view} />
            </tr>
          </tbody>
        </OverlayTable>
      ) : null}
    </DragOverlay>,
    document.body
  );

export default LimitedListDragOverlay;
